<footer class="footer" role="contentinfo" aria-label="Piè di pagina MyLiteLED">

  <!-- Main footer content -->
  <div class="footer__inner">
    <div class="footer__main-grid">

      <!-- Column 1: Logo + Info azienda + Contatti + Pagamento -->
      <div class="footer__col-left">
        <img
          src="assets/images/footer/MLL-logo2018white.svg"
          alt="MyLiteLED - torna alla home"
          class="footer__logo"
          width="160"
          height="56"
        />

        <address class="footer__address">
          <p class="footer__brand-note">MyLiteLED è un marchio NOVA PUBBLICITÀ Srl Unipersonale</p>
          Via S. Bocconcello, 6<br>
          36040 Meledo di Sarego (VI) - Italy<br>
          PIVA 01948000243<br>
          <a href="mailto:info@myliteled.com" class="footer__link footer__link--accent">info@myliteled.com</a>
        </address>

        <p class="footer__contact-label">Contattaci</p>
        <a href="tel:+390444821261" class="footer__phone" aria-label="Chiama il numero +39 0444 821 261">
          +39 0444 821 261
        </a>

        <p class="footer__payment-label">Metodi di pagamento</p>
        <ul class="footer__payment-list" aria-label="Metodi di pagamento accettati">
          <li>
            <img src="assets/images/footer/logo_visa.svg" alt="Visa" class="footer__payment-logo" width="45" height="28">
          </li>
          <li>
            <img src="assets/images/footer/logo_mastercard.svg" alt="Mastercard" class="footer__payment-logo" width="45" height="28">
          </li>
          <li>
            <img src="assets/images/footer/logo_paypal.svg" alt="PayPal" class="footer__payment-logo" width="60" height="28">
          </li>
        </ul>
      </div>

      <!-- Columns 2-4: link groups -->
      <nav class="footer__links-group" aria-label="Link footer">

        <!-- Informazioni -->
        <div class="footer__col-links">
          <h2 class="footer__col-title">Informazioni</h2>
          <ul class="footer__nav-list">
            <li>
              <a href="https://www.myliteled.com/pages/about" class="footer__nav-link">Chi siamo</a>
            </li>
            <li>
              <a href="https://www.myliteled.com/pages/contact" class="footer__nav-link">Contattaci</a>
            </li>
          </ul>
        </div>

        <!-- My Account -->
        <div class="footer__col-links">
          <h2 class="footer__col-title">My account</h2>
          <ul class="footer__nav-list">
            <li>
              <a href="https://www.myliteled.com/pages/register" class="footer__nav-link">Registrazione</a>
            </li>
            <li>
              <a href="https://www.myliteled.com/pages/login" class="footer__nav-link">Login</a>
            </li>
            <li>
              <a href="https://www.myliteled.com/shop/cart" class="footer__nav-link">Carrello</a>
            </li>
            <li>
              <a href="/shop/wishlist" class="footer__nav-link">Wishlist</a>
            </li>
          </ul>
        </div>

        <!-- Customer service -->
        <div class="footer__col-links">
          <h2 class="footer__col-title">Customer service</h2>
          <ul class="footer__nav-list">
            <li>
              <a
                href="https://www.myliteled.com/assets/download/condizioni-di-vendita-ESHOP_MYLITELED.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__nav-link"
                aria-label="Termini e Condizioni (apre in nuova scheda)"
              >Termini e Condizioni</a>
            </li>            
            <li>
              <a
                href="https://www.myliteled.com/assets/download/DirittoDiRecesso-ESHOP_MYLITELED.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__nav-link"
                aria-label="Diritto di recesso (apre in nuova scheda)"
              >Diritto di recesso</a>
            </li>
            <li>
              <a
                [href]="privacyLinks.informativa"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__nav-link"
                aria-label="Privacy Policy (apre in nuova scheda)"
              >Privacy Policy</a>
            </li>
            <li>
              <a
                [href]="privacyLinks.cookie"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__nav-link"
                aria-label="Cookies Policy (apre in nuova scheda)"
              >Cookies Policy</a>
            </li>
            <li>
              <a
                href="https://www.myliteled.com/assets/download/MyLiteLED-accessibility.pdf"
                target="_blank"
                rel="noopener noreferrer"
                class="footer__nav-link"
                aria-label="Dichiarazione di Accessibilità (apre in nuova scheda)"
              >Dichiarazione di Accessibilità</a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>

  <!-- Horizontal divider -->
  <hr class="footer__hr" aria-hidden="true" />

  <!-- Secondary bar: logos + social -->
  <div class="footer__bottom-wrapper">
    <div class="footer__bottom-bar">

      <!-- Partner logos -->
      <div class="footer__partners" aria-label="Siti collegati">
        <a href="https://www.novapubblicita.com/" target="_blank" rel="noopener noreferrer" aria-label="Nova Pubblicità (apre in nuova scheda)">
          <img src="assets/images/footer/logo-nova-white-nopayoff.svg" alt="Nova Pubblicità" class="footer__partner-logo footer__partner-logo--nova" width="100" height="24">
        </a>
        <a href="https://www.materika.com/" target="_blank" rel="noopener noreferrer" aria-label="Materika (apre in nuova scheda)">
          <img src="assets/images/footer/materika_logo-white.svg" alt="Materika" class="footer__partner-logo footer__partner-logo--materika" width="90" height="16">
        </a>
      </div>

      <!-- Social icons -->
      <ul class="footer__social-list" aria-label="Seguici sui social">

        <li>
          <a
            href="https://www.facebook.com/myliteled/"
            target="_blank"
            rel="noopener noreferrer"
            class="footer__social-icon"
            aria-label="Seguici su Facebook (apre in nuova scheda)"
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
            </svg>
          </a>
        </li>

        <li>
          <a
            href="https://www.linkedin.com/company/myliteled"
            target="_blank"
            rel="noopener noreferrer"
            class="footer__social-icon"
            aria-label="Seguici su LinkedIn (apre in nuova scheda)"
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
              <rect x="2" y="9" width="4" height="12"/>
              <circle cx="4" cy="4" r="2"/>
            </svg>
          </a>
        </li>

        <li>
          <a
            href="https://www.youtube.com/@myliteledscritteluminose"
            target="_blank"
            rel="noopener noreferrer"
            class="footer__social-icon"
            aria-label="Seguici su YouTube (apre in nuova scheda)"
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.96-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
              <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#2d2d2d"/>
            </svg>
          </a>
        </li>

        <li>
          <a
            href="https://www.instagram.com/myliteled"
            target="_blank"
            rel="noopener noreferrer"
            class="footer__social-icon"
            aria-label="Seguici su Instagram (apre in nuova scheda)"
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
              <path fill="#2d2d2d" d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
              <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="#2d2d2d" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </a>
        </li>

        <li>
          <a
            href="https://x.com/myliteled"
            target="_blank"
            rel="noopener noreferrer"
            class="footer__social-icon"
            aria-label="Seguici su X, precedentemente Twitter (apre in nuova scheda)"
          >
            <svg width="16" height="16" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622 5.911-5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>
        </li>

      </ul>
    </div>
  </div>

  <!-- Copyright bar -->
  <div class="footer__copyright-bar">
    <div class="footer__copyright-inner">
      <p class="footer__copyright-text">© {{ currentYear }} NOVA Pubblicità. Tutti i diritti riservati.</p>
      <p class="footer__copyright-links">
        <a
          [href]="privacyLinks.informativa"
          target="_blank"
          rel="noopener noreferrer"
          class="footer__copyright-link"
          aria-label="Privacy Policy (apre in nuova scheda)"
        >Privacy Policy</a>
        <span class="footer__copyright-sep" aria-hidden="true">•</span>
        <a
          [href]="privacyLinks.cookie"
          target="_blank"
          rel="noopener noreferrer"
          class="footer__copyright-link"
          aria-label="Cookies Policy (apre in nuova scheda)"
        >Cookies Policy</a>
      </p>
    </div>
  </div>

</footer>
<a href="javascript:void(0)" class="elmo-show"><span>Preferenze <br />Cookie</span><img></a>